import React from 'react';

import Context        from '../../../../../../context';
import validations    from '../../../../../../validations';
import CustomCheckbox from '../../../../../../components/CustomCheckbox';

import { useFormik         } from 'formik';
import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';

import {
  CustomInput,
  CustomModal,
  CustomButton2,
  CustomLeaflet,
  ResponsiveView,
  LocationDropdowns,
} from '../../../../../../components';

import './index.sass';

const Update: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [location, setLocation] = React.useState<Array<number | undefined>>([]);
  const { showModal, setShowModal, updateFunction, isLoading, selectedArea } = React.useContext(Context.Location.Area);
  const [selectedProvince, setSelectedProvince] = React.useState<locationNamespace.province.index>();
  const [selectedCity    , setSelectedCity    ] = React.useState<locationNamespace.city    .index>();
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  const formik = useFormik<locationNamespace.area.create>({
    enableReinitialize: true,
    initialValues: {
      isCapital: selectedArea?.isCapital,

      key        : selectedArea?.key,
      name       : selectedArea?.name || '',
      prefix     : selectedArea?.prefix,
      description: selectedArea?.description,

      code      : selectedArea?.code,
      population: selectedArea?.population,

      // location: {
      //   type: 'Point',
      //   coordinates: [NaN, NaN],
      // }
    },
    validationSchema: validations.location.province.create,
    onSubmit: (values: locationNamespace.area.create, { setSubmitting }) => {
      const newValues: locationNamespace.area.create = {
        ...values,
        city     : selectedCity ? selectedCity?._id : selectedArea?.city._id,
        // location: {
        //   type: 'Point',
        //   coordinates: [
        //     location[0] ? Number(location[0]) : Number(selectedArea?.location?.coordinates[0]),
        //     location[1] ? Number(location[1]) : Number(selectedArea?.location?.coordinates[1]),
        //   ]
        // }
      }
      Promise.resolve(updateFunction!(newValues)).catch((e) => setSubmitting(false));
    },
  });

  async function submitHandler(): Promise<void> {
    await formik.submitForm();
  }

  function handleChangeLocation(lat: any, lng: any): void {
    setLocation([lat, lng]);
  }

  function onSelectProvince(province: locationNamespace.province.index): void {
    if (!province) return;
    setSelectedProvince(province);
  }

  function onSelectCity(city: locationNamespace.city.index): void {
    if (!city) return;
    setSelectedCity(city);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect(() => {
    setLocation([
      selectedArea?.location?.coordinates[0] || undefined,
      selectedArea?.location?.coordinates[1] || undefined,
    ])
  }, [selectedArea]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="parent-update-modal-container">
      <form onSubmit={submitHandler}>
        <CustomModal label='ویرایش منطقه' open={showModal === 'UPDATE'} onClose={() => setShowModal!('NONE')}>
          <ResponsiveView.Container className="create-form-content">
            <br/>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.Province
                  onSelectItem = { onSelectProvince }
                  defaultItem  = { selectedProvince ? selectedProvince : selectedArea?.province }
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <LocationDropdowns.City
                  selectedProvince= { selectedProvince ? selectedProvince : selectedArea?.province }
                  onSelectItem    = { onSelectCity     }
                  defaultItem     = { selectedCity ? selectedCity : selectedArea?.city}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column medium={6}>
                <CustomInput
                  id='name'
                  name='name'
                  label={'نام منطقه'}
                  value={formik.values.name}
                  error={formik.errors.name && formik.touched.name}
                  errorText={formik.errors.name}
                  formikProps={{onBlur: formik.handleBlur}}
                  onValueChange={formik.handleChange}
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column medium={6}>
                <CustomCheckbox label='مرگز استان میباشد'/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br/>
            <ResponsiveView.Row className='form-row'>
              <ResponsiveView.Column small={12}>
                <CustomLeaflet
                  onChangeLatAndLng={handleChangeLocation}
                  defaultLat={location[0] ? location[0] : selectedArea?.location?.coordinates[0]}
                  defaultLng={location[1] ? location[1] : selectedArea?.location?.coordinates[1]}
                  defaultLatArea={selectedArea?.location ? selectedArea?.location.coordinates[0] : selectedCity?.location?.coordinates[0]}
                  defaultLngArea={selectedArea?.location ? selectedArea?.location.coordinates[1] : selectedCity?.location?.coordinates[1]}
                />
              </ResponsiveView.Column>
            </ResponsiveView.Row>
            <br />
            <hr/>
            <ResponsiveView.Row className="form-row">
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </ResponsiveView.Column>
              <ResponsiveView.Column large={6} medium={6} small={12}>
                <CustomButton2 isLoading={isLoading} onClick={submitHandler} title={t("submit")}/>
              </ResponsiveView.Column>
            </ResponsiveView.Row>
          </ResponsiveView.Container>
        </CustomModal>
      </form>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Update;
